window.FORUM_UTILS = window.FORUM_UTILS || { };

// Initializing Markdown editor with a custom parser
window.FORUM_UTILS.initializeMarkdownEditor = function() {

	$( "textarea[data-provide=markdown]" ).markdown( {
		parser: function( source ) {
			$.ajax( {
				type: "POST",
				url: "/api/cs/markdown/transform/",
				data: {
					source: source
				},
				success: function( output ) {
					$( "#md-preview-replacement" ).replaceWith( output );
				}
			} );
			return "<i id=\"md-preview-replacement\"" +
				" class=\"glyphicon glyphicon-time\"></i>";
		}
	} );
};

// Usage: window.FORUM_UTILS.livePreview( "id_body" );
window.FORUM_UTILS._lastSourcePreviewed = "";
window.FORUM_UTILS.livePreview = function( elementId ) {
	var source, _elementId;

	_elementId = "#" + elementId;
	source = $( _elementId ).val();

	if ( !( source == window.FORUM_UTILS._lastSourcePreviewed ) ) {

		$.ajax( {
			type: "POST",
			url: "/api/cs/markdown/transform/",
			data: {
				source: source
			},
			success: function( output ) {
				var previewHeight, previewScrollHeight, srcHeight,
					srcScrollTop, srcScrollHeight, srcMiddle, newTop;

				$( "#preview" ).html( output );

				srcHeight = $( _elementId ).innerHeight();
				srcScrollTop = $( _elementId ).scrollTop();
				srcScrollHeight = $( _elementId )[ 0 ].scrollHeight;
				previewHeight = $( "#preview" ).innerHeight();
				previewScrollHeight = $( "#preview" )[ 0 ].scrollHeight;

				srcMiddle = ( srcScrollTop + ( srcHeight / 2.0 ) ) / srcScrollHeight;

				newTop = previewScrollHeight * srcMiddle - ( previewHeight / 2.0 );

				$( "#preview" ).scrollTop( newTop );
			}
		} );
		window.FORUM_UTILS._lastSourcePreviewed = source;
	}

	setTimeout( function() { window.FORUM_UTILS.livePreview( elementId ); }, 1000 );
};
